import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { SelectedEventArgs } from '@syncfusion/ej2-angular-inputs';
import { EmitType } from '@syncfusion/ej2-base';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';

@Component({
    selector: 'my-import-file-dialog',
    templateUrl: './my-import-file-dialog.html',
})
export class MyImportFileDialogComponent {
    @ViewChild('dlg') dlg: DialogComponent;
    visible: boolean = false;
    isChanged: boolean = false;
    params: any = null;
    callback: any = null;
    retData: any = null;
    url: string = null;
    msg: string = null;
    files: any = null;

    constructor(private cdr: ChangeDetectorRef, private http: HttpService, private helper: HelperService) {
    }

    show(url: string, params: any, callback) {
        this.url = url;
        this.params = params;
        this.callback = callback;        
        this.msg = null;
        this.dlg.show();
    } 

    onSelectedFile(evt: any) {
        this.files = evt.target.files;
        this.msg = null;
    }

    onImport() {
        let files = this.files;

        if (files && files.length > 0) {
            let file = files[0];
            let data = new FormData();
            data.append('files', file, file.name);

            if (this.params != null) {
                this.params.forEach(p => {
                    let keys = Object.getOwnPropertyNames(p);
                    let key = keys[0];
                    data.append(key, '' + p[key]);
                });
            }

            this.http.post(this.url, data, res => {
                console.log('import count: ', res.Count);
                this.retData = res;
                this.msg = `${res.Count} items imported`;
                this.isChanged = true;

                (<HTMLInputElement>document.getElementById('file')).value = "";
                this.cdr.detectChanges();

            }, (err) => {
                this.msg = 'Import failed'
                this.cdr.detectChanges();

                if (err != null)
                    this.helper.alertFailed(err.ErrorMessages[0], 'Import failed');
            });
        }
    }

    onClose(evt: any) {
        if (this.callback != null && this.isChanged)
            this.callback(this.retData);
    }
}
